import ProductConfigurationProvider from './product-configuration-provider';

export const resolvedProductConfigurationProvider = new ProductConfigurationProvider();
